import React from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined'

export default function CallResponseViewer({ callResponses = [] }) {
  if (!callResponses?.length) return null

  return (
    <Accordion variant='outlined' sx={{ '&:before': { display: 'none' }, borderRadius: '6px !important' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 40, '& .MuiAccordionSummary-content': { my: 0.5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <QuestionAnswerOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
          <Typography variant='caption' sx={{ fontWeight: 700 }}>
            IVR Responses ({callResponses.length})
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        {callResponses
          .sort((a, b) => (a.positionInList || 0) - (b.positionInList || 0))
          .map((cr, idx) => (
            <Box key={idx} sx={{ mb: 1.5, pl: 1, borderLeft: '3px solid', borderColor: 'primary.light' }}>
              <Typography variant='caption' sx={{ fontWeight: 700, color: 'text.secondary' }}>
                Q{idx + 1}: {cr.question}
              </Typography>
              <Typography variant='body2' sx={{ fontWeight: 600, mt: 0.25 }}>
                {cr.answer || '(no answer)'}
              </Typography>
            </Box>
          ))
        }
      </AccordionDetails>
    </Accordion>
  )
}
